import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import { Row, Col, ListGroup } from 'reactstrap'
import ListItemOption from 'ui/list_item_option'
import { useTranslation } from 'react-i18next'
import { get } from 'lodash'
import parse from 'react-html-parser'

const ComponentBlocks = ({ components, component_selections, onComponentSeleted }) => (
  <Row>
    {components.map(({ product_id, channel_id, tour_id, tour_title, components }) => (
      <Col xs="12" className="mt-1 mb-3" key={tour_id}>
        <h3>{tour_title}</h3>
        <ComponentSelect
          product_id={product_id}
          channel_id={channel_id}
          tour_id={tour_id}
          components={components}
          component_selections={component_selections}
          onComponentSeleted={onComponentSeleted}
        />
      </Col>
    ))}
  </Row>
)

const ComponentSelect = ({
  product_id,
  channel_id,
  tour_id,
  components,
  component_selections,
  onComponentSeleted
}) => {
  const { t, i18n } = useTranslation()
  const componentsList = Array.isArray(components) ? components : [components]

  if (!components || components.length <= 0) {
    return (
      <div className="alert alert-warning">
        {i18n.t('tourcms_component_module.no_availability')}
      </div>
    )
  }

  return (
    <ListGroup>
      {componentsList.map((c) => {
        const {
          component_key,
          date_code,
          note,
          special_offer_note,
          price_breakdown
        } = c

        const price = get(price_breakdown, 'price_row')
        const priceList = Array.isArray(price) ? price : [price]

        const componentDescription = (date_code, note, special_offer_note) => {
          let text
          if (date_code || note) {
            if (date_code && note) text = `${date_code} - ${note}`
            else if (!date_code) text = note
            else text = date_code
          } else {
            text = special_offer_note
          }
          return <div>{text}</div>
        }

        return (
          <ListItemOption
            key={component_key}
            active={
              component_selections[tour_id]?.component_key === component_key
            }
            onClick={() =>
              onComponentSeleted({
                component: c,
                product_id,
                tour_id,
                channel_id
              })
            }
          >
            <div className="align-self-center text-center text-md-start">
              <div className="fw-bold">
                {componentDescription(date_code, note, special_offer_note)}
              </div>
              <div>
                {priceList.map((p) => (
                  <span key={p['rate-id']} className="me-3">
                    {parse(p.label)}
                  </span>
                ))}
              </div>
            </div>
          </ListItemOption>
        )
      })}
    </ListGroup>
  )
}

const TourcmsPackModule = (props) => {
  const { machine, status } = props
  const { t, i18n } = useTranslation()
  const [current, send] = machine
  const { components, component_selections } = current.context

  const isFetching = current.matches({
    tourcmsPackStep: 'fetchingComponents'
  })
  const unavailableComponents = current.matches({
    tourcmsPackStep: 'unavailableComponents'
  })

  const onComponentSeleted = ({
    component,
    product_id,
    tour_id,
    channel_id
  }) =>
    send({
      type: 'COMPONENT_SELECTION',
      component,
      product_id,
      channel_id,
      tour_id
    })

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed' ? send('REOPEN_TOURCMSPACKSTEP') : null
        }
      >
        <span>
          <i className="fa fa-star me-2" aria-hidden="true"></i>
          {i18n.t('tourcms_component_module.select_a_modality')}
        </span>
      </ModuleHeader>

      <ModuleBody status={status}>
        {isFetching ? (
          <div className="alert alert-light" role="alert">
            <i className="far fa-clock me-2" aria-hidden="true"></i>
            {i18n.t('tourcms_component_module.searching_modalities')}
          </div>
        ) : (
          <>
            {unavailableComponents && (
              <div className="alert alert-light">
                {i18n.t('tourcms_component_module.no_availability')}
              </div>
            )}

            {components && (
              <ComponentBlocks
                components={components}
                component_selections={component_selections}
                onComponentSeleted={onComponentSeleted}
              />
            )}
          </>
        )}
      </ModuleBody>

      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default TourcmsPackModule